<template>
    <div v-if="isOK" class="activitydetail">
        <OfficialBar v-if="activeInfo.subqrcodeurl" ref="OfficialBar" @showOfficialImg="showOfficialQR"></OfficialBar>
        <div class="banner_box">
            <div class="banner"
                 :style="{background: 'url(' + activeInfo.coveratturl + ')', backgroundSize: 'cover'}"></div>
            <div class="bottom_bg"
                 :style="{background: 'url('+ require('@/common/images/activeTools/circle_icon.png') +')', backgroundSize:'100% 110%', backgroundRepeat:'no-repeat'}"></div>
            <div class="cover_img">
                <img :src="activeInfo.coveratturl">
            </div>
            <div class="eye_share flex_s">
                <div class="flex_s"><img :src="require('@/common/images/activeTools/eye.png')" class="eye">{{activeInfo.viewcount}}
                </div>
                <img v-if="activeInfo.isposter === '1'" :src="require('@/common/images/activeTools/share.png')" alt="分享"
                     class="share" @click="shareEvent">
            </div>
        </div>
        <div class="active_info">
            <h3>{{activeInfo.title}}</h3>
            <div class="info_desp">{{activeInfo.subtitle}}</div>
            <div class="info_price flex_s">
                <span class="price"><span v-if="activeInfo.saleprice !== '免费'">¥ </span>{{activeInfo.saleprice}}</span>
                <span class="price_tips">{{activeInfo.isrefund ? '' : '不'}}支持退款</span>
            </div>
            <div class="time_add_num">
                <div class="info_time flex_s">
                    <img :src="require('@/common/images/activeTools/time_icon.png')">
                    <p>{{activeInfo.begintime}} - {{activeInfo.endtime}}</p>
                </div>
                <div class="info_addr flex_s">
                    <img :src="require('@/common/images/activeTools/address_icon.png')">
                    <p>{{activeInfo.address}}</p>
                </div>
                <div class="info_num flex_s">
                    <img :src="require('@/common/images/activeTools/group_icon.png')">
                    <p>
                        <span v-if="activeInfo.ticketcount">限{{activeInfo.ticketcount}}人</span>
                        <span v-else>不限人数</span>
                        <span v-if="activeInfo.isdisplayenrollcount"> | 已报名{{activeInfo.currentenrollcount}}人</span>
                    </p>
                </div>
            </div>
        </div>
        <div v-if="activeInfo.isdisplayenrollinfo && orderList.length>0" class="apply_num flex_s"
             @click="jumpParticipant">
            <span>参与人员</span>
            <div class="flex_s fixed_box">
                <div v-for="(item, index) in orderList" :key="index">
                    <img :src="item.customericonurl" v-if="index<8" :style="{left: index*0.6 + 'rem'}">
                </div>
                <img v-if="orderList.length>7" :src="require('@/common/images/activeTools/more_icon.png')"
                     :style="{'left': orderList.length>=8 ? (orderList.length)*0.6 + 'rem' : (orderList.length-1)*0.6 + 'rem'}">
            </div>
        </div>
        <!-- 主办方信息 -->
        <div class="hostinfo flex_s" @click="goHostinfo">
            <div class="left flex_s">
                <div class="img"><img :src="activeInfo.hostinfo.hostpic" alt=""></div>
                <div class="msg">
                    <div class="hostname">{{activeInfo.hostinfo.hostname}}</div>
                    <div class="count_box">
                        <span>活动数 {{activeInfo.hostinfo.eventcount}}</span>
                        <span class="line">|</span>
                        <span>粉丝数 {{activeInfo.hostinfo.favoritecount}}</span>
                    </div>
                </div>
            </div>
            <div class="right">
                <img :src="require('@/common/images/index/icon-right.png')" alt="">
            </div>
        </div>
        <div class="active_detail" v-if="activeInfo.eventdesp" v-html="activeInfo.eventdesp"></div>

        <!-- 底部按钮 -->
        <div v-if="activeInfo.status !== '9'" class="fixed_footer">
            <div v-if="activeInfo.status === '100'" class="is_cancel">活动已取消</div>
            <div v-if="activeInfo.status === '30'" class="is_cancel">活动已结束</div>
            <div v-if="activeInfo.status === '10'" @click="signUp">立即报名</div>
        </div>

        <!-- 右侧悬浮按钮 -->
        <div class="right_float flex_s">
            <div @click="goIndex" class="flex_s"
                 :style="{'border-radius': this.activeInfo.qrcodeatturlid ? '.1rem .1rem 0 0' : '.1rem', 'border-bottom': this.activeInfo.qrcodeatturlid ? '.01rem solid rgba(255,255,255,.5)' : 'unset'}">
                <img :src="require('@/common/images/activeTools/index_icon.png')">
            </div>
            <div v-if="this.activeInfo.qrcodeatturlid" @click="serviceEvent" class="flex_s"
                 :style="{'border-radius': ' 0 0 .1rem .1rem'}">
                <img :src="require('@/common/images/activeTools/service_icon.png')">
            </div>
        </div>

        <!-- 活动未开始弹窗 -->
        <van-popup v-model="unStartTips" class="unstart_tips flex_s" :close-on-click-overlay="false">
            <h3>该活动还未开始报名哦!</h3>
            <div class="tips_time flex_s">
                <p>报名时间</p>
                <p>{{activeInfo.begintime}}</p>
                <p>至</p>
                <p>{{activeInfo.endtime}}</p>
            </div>
            <div class="ikown_btn" @click="unStartTips=false">我知道了</div>
        </van-popup>

        <!-- 弹窗 -->
        <OfficialAlert ref="OfficialAlert"></OfficialAlert>
        <Poster ref="Poster"></Poster>
        <ToPay ref="toPay"></ToPay>
    </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import {getEventInfo} from 'api/activeTools.js'
  import OfficialBar from '../components/officialBar'
  import OfficialAlert from '../components/officialAlert'
  import ToPay from '../components/toPay'
  import Poster from '../components/poster'
  // import {wxLogin} from 'common/js/mixin'
  import {getWXSDKSetting} from 'common/js/wxSDKSetting'
  import {loginInfo} from 'common/js/loginInfo'
  import { getAssignKeyLocationSearch, setCookie } from 'common/js/tools.js'
  import {getCustomerInfoByApp} from 'api/api'

  export default {
    name: 'ActivityDetail',
    // mixins: [wxLogin],
    data() {
      return {
        eventid: this.$route.query.eventid ? this.$route.query.eventid : '1000016',
        activeInfo: {},
        orderList: {},
        unStartTips: false,
        isOK: false,
        isTicket: ''
      }
    },
    created() {
        if(!this.domainInfo.isMobile){
            this.$router.push({name: 'HdDetails',query: {'eventid': this.$route.query.eventid}})
        }
        if (getAssignKeyLocationSearch('apptoken') && getAssignKeyLocationSearch('appflag', ['appByDM'])) {
            this.getCustomerInfoByApp()
        }
    },
    mounted() {
      if (!this.refresh) {
        this.getActiveInfo()
      }
    },
    activated() {
      if (this.refresh) {
        this.eventid = this.$route.query.eventid ? this.$route.query.eventid : ''
        this.getActiveInfo()
        this.setRefresh(false)
      }
    },
    methods: {
        getCustomerInfoByApp() {
            this.setLoading(true)
            getCustomerInfoByApp({
                data: {},
                success: data => {
                    let user = {
                        innerid: data.data.innerid ? data.data.innerid : '',
                        isperfect: data.data.isperfect ? data.data.isperfect : '',
                        loginToken: data.data.logintoken ? data.data.logintoken : '',
                        loginname: data.data.loginname ? data.data.loginname : '',
                        logourl: data.data.logourl ? data.data.logourl : '',
                        mobile: data.data.mobile ? data.data.mobile : '',
                        name: data.data.name ? data.data.name : '',
                        nickname: data.data.nickname ? data.data.nickname : '',
                        isLogin: true,
                        zjmemtype: data.data.zjmemtype ? data.data.zjmemtype : 0
                    }
                    this.setUser(user)
                    sessionStorage.setItem('user', JSON.stringify(user))
                    setCookie('token', user.loginToken, 7)
                },
                error: data => {
                    this.setLoading(false)
                    // this.$toast.fail(data.msg)
                }
            })
        },
        getActiveInfo() {
            let data = {
            eventid: this.eventid
            }
            getEventInfo({
            data: data,
            success: data => {
                this.setLoading(false)
                if (data.data) {
                this.isOK = true
                this.activeInfo = data.data.eventinfo
                this.activeInfo.enrolleventorderitem = this.activeInfo.enrolleventorderitem ? this.activeInfo.enrolleventorderitem : []
                this.orderList = data.data.enrolleventorderitem
                // this.activeInfo.status = '9'
                this.unStartTips = this.activeInfo.status === '9' || this.activeInfo.status === 9 ? true : false
                this.isTicket = data.data.ticketurl
                document.title = this.activeInfo.title
                if (data.data.orderinfo.paystatus === 9 || data.data.orderinfo.paystatus === 1) {
                    this.$nextTick(() => {
                    this.$refs.toPay.showDialog(data.data.orderinfo.payurl, this.eventid)
                    })
                }
                if (this.ClientType === 3) {
                    let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?eventid=' + this.eventid
                    getWXSDKSetting({
                        title: this.activeInfo.eventsharesubject ? this.activeInfo.eventsharesubject : this.activeInfo.title,
                        desc: this.activeInfo.eventsharecontent ? this.activeInfo.eventsharecontent : this.activeInfo.subtitle,
                        link: link,
                        imgUrl: this.activeInfo.eventshareatturl ? this.activeInfo.eventshareatturl : this.activeInfo.coveratturl
                    })
                }
                }
            },
            error: data => {
                this.setLoading(false)
                this.$toast.fail(data.msg)
            }
            })
        },
        _isWixin() {
            let ua = window.navigator.userAgent.toLowerCase()
            if (/micromessenger/.test(ua)) {
                return true
            } else {
                return false
            }
        },

        // 分享
        shareEvent() {
            this.$refs.Poster.open(this.eventid)
        },

        // 公众号二维码
        showOfficialQR() {
            this.$refs.OfficialAlert.showDialog(this.activeInfo.subqrcodeurl, this.activeInfo.subqrcodename, this.activeInfo.subqrcodename ? 0 : 1)
        },

        // 客服二维码
        serviceEvent() {
            this.$refs.OfficialAlert.showDialog(this.activeInfo.qrcodeatturlid, this.activeInfo.servicebuttontext, 0)
        },

        // 立即报名
        signUp() {
            if (this.user.loginToken) {
                this.setRefresh(true)
                this.$router.push({name: 'ChooseTickets', query: {eventid: this.eventid}})
            } else {
                if (this.ClientType === 3) {
                    loginInfo()
                } else {
                    this.$router.push({name: 'MLogin'})
                }
            }
        },

        // 报名人员
        jumpParticipant() {
            this.$router.push({name: 'Participants', query: {eventid: this.eventid}})
        },

        // 去首页
        goIndex() {
            this.$router.push({name: 'ApplyIndex'})
        },
        goHostinfo() {
            this.setRefresh(true)
            this.$router.push({name: 'AaHostView', query: {hostid: this.activeInfo.hostinfo.hostid}})
        },
        ...mapActions([
            'setLoading',
            'setIsInit',
            'setRefresh',
            'setUser'
        ])
    },
    watch: {
      user(newVal, oldVal) {
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
          return
        }
        this.$nextTick(() => {
          this.getActiveInfo()
        })
      }
    },
    computed: {
      ...mapGetters([
        'user', 'refresh', 'domainInfo', 'ClientType'
      ])
    },
    components: {
      OfficialBar,
      OfficialAlert,
      Poster,
      ToPay
    }
  }
</script>

<style lang="scss">
    .flex_s {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .activitydetail {
        background: #F5F7FA;
        width: 100%;
        overflow: hidden;
        .banner_box {
            width: 100%;
            position: relative;
            height: 4.35rem;
            overflow: hidden;
            .banner {
                width: 100%;
                height: 100%;
                background: #acd;
                filter: blur(.5rem);
            }
            .bottom_bg {
                position: absolute;
                bottom: -.05rem;
                left: 0;
                width: 100%;
                height: 1.62rem;
            }
            .cover_img {
                width: 6.85rem;
                height: 3.85rem;
                position: absolute;
                left: .3rem;
                top: .4rem;
                border-radius: .15rem;
                box-shadow: 0 .04rem .08rem rgba(0, 0, 0, .3);
                img {
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                    border-radius: .15rem;
                }
            }
            .eye_share {
                position: absolute;
                top: .6rem;
                left: .6rem;
                width: 6.3rem;
                justify-content: space-between;
                font-size: .24rem;
                color: #fff;
                img {
                    display: inline-block;
                }
                .eye {
                    width: .35rem;
                    height: .22rem;
                    margin-right: .1rem;
                }
                .share {
                    width: 1.32rem;
                    height: .6rem;
                }
            }
        }
        .active_info {
            padding: .4rem .3rem 0;
            background: #fff;
            h3 {
                font-size: .38rem;
                color: #303133;
                font-weight: 600;
                line-height: .55rem;
            }
            .info_desp {
                font-size: .26rem;
                color: #666;
                margin: .2rem 0;
                line-height: .36rem;
                max-height: .76rem;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            .info_price {
                .price {
                    font-size: .44rem;
                    color: #0ABF53;
                    margin-right: .2rem;
                    font-weight: 600;
                    span {
                        font-size: .3rem;
                    }
                }
                .price_tips {
                    display: inline-block;
                    font-size: .2rem;
                    color: #FF4747;
                    width: 1.4rem;
                    height: .4rem;
                    border-radius: .06rem;
                    text-align: center;
                    line-height: .4rem;
                    border: .01rem solid #FF4747;
                }
            }
            .time_add_num {
                padding: .3rem 0 .2rem;
                div {
                    margin-bottom: .2rem;
                    font-size: .28rem;
                    color: #666;
                    img {
                        display: inline-block;
                        width: .3rem;
                        height: .3rem;
                        margin-right: .2rem;
                    }
                    p {
                        line-height: .34rem;
                    }
                }
            }
        }
        .apply_num {
            height: 1.2rem;
            background: #fff;
            padding: 0 .3rem;
            margin-top: .2rem;
            span {
                font-size: .28rem;
                color: #333333;
                padding-right: .2rem;
                font-weight: 600;
            }
            .fixed_box {
                width: 5.5rem;
                justify-content: space-between;
                position: relative;
                img {
                    display: inline-block;
                    width: .68rem;
                    height: .68rem;
                    border-radius: 50%;
                    position: absolute;
                    top: 50%;
                    margin-top: -.34rem;
                }
            }
        }
        .hostinfo {
            padding: 0.24rem 0.32rem;
            background: #fff;
            margin-top: 0.2rem;
            justify-content: space-between;
            .left {
                .img {
                    width: 1rem;
                    height: 1rem;
                    margin-right: 0.24rem;
                    img {
                        width: 1rem;
                        height: 1rem;
                    }
                }
                .msg {
                    .hostname {
                        width: 3.06rem;
                        line-height: 0.45rem;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-size: 0.32rem;
                        font-weight: bold;
                        margin-bottom: 0.12rem;
                    }
                    .count_box {
                        font-size: 0.24rem;
                        color: #999999;
                        .line {
                            margin: 0 0.2rem;
                        }
                    }
                }
            }
            .right {
                img {
                    width: 0.16rem;
                    height: 0.26rem;
                }

            }
        }
        .active_detail {
            background: #fff;
            padding: .3rem;
            margin: .2rem 0 1.2rem;
            width: 100%;
            box-sizing: border-box;
            * {
                line-height: .5rem;
            }
            img, video {
                width: 100%;
                height: auto;
            }
        }
        .fixed_footer {
            position: fixed;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 1.1rem;
            background: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            div {
                width: 6.84rem;
                height: .76rem;
                background: linear-gradient(360deg, rgba(10, 191, 83, 1) 0%, rgba(71, 236, 201, 1) 100%);
                border-radius: .4rem;
                font-size: .3rem;
                color: #fff;
                line-height: .76rem;
                text-align: center;
            }
            .is_cancel {
                background: linear-gradient(180deg, rgba(151, 237, 205, 1) 0%, rgba(133, 224, 172, 1) 100%, rgba(132, 223, 169, 1) 100%);
            }
        }
        .right_float {
            position: fixed;
            right: .3rem;
            bottom: 1.2rem;
            border-radius: .1rem;
            flex-direction: column;
            justify-content: space-between;
            background: rgba(0, 0, 0, .45);
            padding: 0 .15rem;
            div {
                width: .55rem;
                height: .88rem;
                flex-direction: column;
                justify-content: center;
                img {
                    display: inline-block;
                    width: .38rem;
                    height: .6rem;
                }
            }
            div:first-child {
                border-radius: .1rem .1rem 0 0;
                border-bottom: .01rem solid rgba(255, 255, 255, .7);
            }
            div:last-child {
                border-radius: 0 0 .1rem .1rem;
            }
        }
        .unstart_tips {
            width: 4.8rem;
            height: 3.8rem;
            border-radius: .15rem;
            flex-direction: column;
            padding: .4rem 0;
            h3 {
                font-size: .34rem;
                color: #666;
            }
            .tips_time {
                height: 1.9rem;
                justify-content: space-between;
                flex-direction: column;
                margin: .4rem 0;
                p {
                    flex: 1;
                    font-size: .28rem;
                    color: #666;
                    line-height: .5rem;
                }
            }
            .ikown_btn {
                width: 3.6rem;
                height: .6rem;
                background: linear-gradient(360deg, rgba(10, 191, 83, 1) 0%, rgba(71, 236, 201, 1) 100%);
                border-radius: .3rem;
                font-size: .28rem;
                color: #fff;
                line-height: .6rem;
                text-align: center;
            }
        }
    }
</style>


